import { History, CheckCircle, Clock, XCircle } from "lucide-react";
import { Card, CardContent, CardHeader } from "../ui/card";
import type { Payment } from "../../types/membership";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

interface PaymentHistoryProps {
  payments: Payment[];
}

export function PaymentHistorySection({ payments }: PaymentHistoryProps) {
  const { language } = useAuth();
  
  return (
    <Card>
      <CardHeader className="p-4 md:p-6">
        <div className="flex items-center space-x-2 md:space-x-3">
          <div className="w-8 h-8 md:w-10 md:h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
            <History className="w-4 h-4 md:w-5 md:h-5 text-gray-600" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-gray-900">
            {dictionary["payment-history"][language]}
          </h3>
        </div>
      </CardHeader>
      <CardContent className="p-4 md:p-6 pt-0">
        <div className="space-y-3 md:space-y-4">
          {payments.map((payment) => (
            <div
              key={payment.id}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-3 md:p-4 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors duration-200 gap-3"
            >
              <div className="flex items-center space-x-3 md:space-x-4 flex-1 min-w-0">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                  <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-gray-600" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-sm md:text-base text-gray-900">
                    ${payment.total_value}
                  </p>
                  <p className="text-xs md:text-sm text-gray-500 truncate">
                    {payment.provider_id} - {payment.origin}
                  </p>
                </div>
              </div>
              <div className="flex sm:flex-col sm:text-right items-center sm:items-end justify-between sm:justify-start gap-2 flex-shrink-0">
                <p className="text-xs md:text-sm font-medium text-gray-900">
                  {new Date(payment.created_at).toLocaleDateString()}
                </p>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 whitespace-nowrap`}>
                  {dictionary["succeeded"][language] || payment.state}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
